/** Etiqueta para select de calendarios laborales */
export function formatCalendarOption(cal) {
  const status = cal.status ? ` · ${cal.status}` : '';
  return `ID ${cal.id} — ${cal.name} (año ${cal.year}${status})`;
}

/** Etiqueta para select de festivos */
export function formatHolidayOption(holiday) {
  const date = formatHolidayDate(holiday.date);
  return `ID ${holiday.id} — ${date} — ${holiday.name}`;
}

/** Normaliza fecha ISO del API a YYYY-MM-DD */
export function formatHolidayDate(dateValue) {
  if (!dateValue) return '—';
  const str = String(dateValue);
  if (str.includes('T')) return str.slice(0, 10);
  return str.slice(0, 10);
}

/** Fecha local YYYY-MM-DD para input[type=date] */
export function toDateInputValue(dateValue) {
  return formatHolidayDate(dateValue);
}

/** Override activo si end_date >= hoy (UTC date) */
export function isOverrideExpired(override) {
  if (!override?.end_date) return false;
  const end = formatHolidayDate(override.end_date);
  const today = new Date().toISOString().slice(0, 10);
  return end < today;
}

/** Override solapa con un año natural */
export function overrideOverlapsYear(override, year) {
  if (!override) return false;
  const start = formatHolidayDate(override.start_date);
  const end = formatHolidayDate(override.end_date);
  const yearStart = `${year}-01-01`;
  const yearEnd = `${year}-12-31`;
  return start <= yearEnd && end >= yearStart;
}

/** Etiqueta de ámbito del override */
export function formatOverrideScope(override, employeeNameById = {}) {
  if (!override?.employee_id) return 'Toda la fábrica';
  const name = employeeNameById[override.employee_id];
  return name ? `Empleado: ${name}` : `Empleado ID ${override.employee_id}`;
}

/** Resumen corto para listados */
export function formatOverrideSummary(override, employeeNameById = {}) {
  const start = formatHolidayDate(override.start_date);
  const end = formatHolidayDate(override.end_date);
  const scope = formatOverrideScope(override, employeeNameById);
  const working = override.is_working_day ? 'Laborable' : 'No laborable';
  const hours =
    override.start_time && override.end_time
      ? ` · ${override.start_time}–${override.end_time}`
      : '';
  return `${start} → ${end} · ${scope} · ${working}${hours}`;
}

/** Mapa fecha (YYYY-MM-DD) → festivo */
export function buildHolidaysByDateMap(holidays = []) {
  const byDate = new Map();
  if (!Array.isArray(holidays)) return byDate;
  holidays.forEach((h) => {
    const key = formatHolidayDate(h.date);
    if (key && key !== '—') byDate.set(key, h);
  });
  return byDate;
}

export function eventDateKey(event) {
  if (!event) return '';
  if (event.extendedProps?.eventDate) {
    return formatHolidayDate(event.extendedProps.eventDate);
  }
  const start = event.start;
  if (typeof start === 'string') return start.slice(0, 10);
  if (start instanceof Date) {
    const y = start.getFullYear();
    const m = String(start.getMonth() + 1).padStart(2, '0');
    const d = String(start.getDate()).padStart(2, '0');
    return `${y}-${m}-${d}`;
  }
  return '';
}

/**
 * Añade holidayId a eventos de festivo registrado (por fecha).
 */
export function attachHolidayIdsToEvents(events, holidays = []) {
  const byDate = buildHolidaysByDateMap(holidays);
  if (byDate.size === 0) return events;

  return events.map((ev) => {
    const props = ev.extendedProps || {};
    if (!props.isRegisteredHoliday && !props.holidayName) {
      return ev;
    }
    const dateStr = eventDateKey(ev);
    const hol = byDate.get(dateStr);
    if (!hol?.id) return ev;
    return {
      ...ev,
      extendedProps: {
        ...props,
        holidayId: hol.id,
        isHoliday: true,
      },
    };
  });
}
